import { useContext } from 'react';
import { LocaleContext } from '../context/LocaleContext';

import fotoProfilo from '../io.jpeg';
import vCard from '../v-card-pietro-lubrano.vcf';
import ProSkill from './ProSkill';
import proSkills from '../data/proSkills.json';
import TypeIt from "typeit-react";

import about from '../data/about.json';

export default function Aside({ setLoaded }){
    const { language, LocaleSwitch } = useContext(LocaleContext)

    return(
        <aside className="col-12 col-md-4 p-4 d-flex flex-column">
            {/* PROFILE PIC */}
            <div className="row mb-5" data-aos="fade-down">
                <div className="col-12 text-center">
                    <LocaleSwitch />
                    <img src={fotoProfilo} className={`rounded-circle border img-fluid`} alt="profile pic" style={{ width: 250 }} onLoad={() => setLoaded(true)}/>
                </div>
                <div className="col-12 d-md-none text-center mt-4">
                    <h1>PIETRO LUBRANO</h1>
                    <h2 className="p lead">
                        <strong>
                            <TypeIt
                                getBeforeInit={(instance) => {
                                    instance
                                        .pause(1000)
                                        .type("JUNIOR FULL STACK DEVELOPER")
                                    // Remember to return it!
                                    return instance;
                                }}
                            />
                        </strong>
                    </h2>
                    {/* <h2 className="p lead"><strong>JUNIOR WEB DEVELOPER</strong></h2> */}
                </div>
            </div>
            
            {/* ABOUT ME */}
            
            <div className="row mb-5">
                
                <div
                    className="col-1 me-4 text-center"
                    data-aos="fade-right"
                    data-aos-delay="100"
                >
                    <i className="fas fa-user-tie fa-2x"></i>
                </div>
                
                <div className="col">
                    <h3 
                        data-aos="fade-right"
                        data-aos-delay="100"
                    >ABOUT ME</h3>
                    <p 
                        className="mt-4 mb-2 aos-about"
                        data-aos="fade-right"
                        data-aos-delay="200"
                    >
                        {about[language][0]}
                        <br />
                        {about[language][1]}
                    </p>
                    <p
                        data-aos-anchor=".aos-about"
                        data-aos="fade-right"
                        data-aos-delay="300"
                    >
                       {about[language][2]}
                    </p>
                </div>
                
            </div>
            
                {/* CONTACT ME */}
            
            <div
                className="row mb-5 aos-contatti"
                data-aos="fade-right"
                data-aos-offset="-300"
                data-aos-delay="400"
            >
                
                <div className="col-1 me-4 text-center">
                    <i className="far fa-envelope fa-2x"></i>
                </div>
                
                <div className="col">
                    <h3>
                        {
                            language === 'ita' ?
                                'CONTATTI'
                            :
                                'CONTACTS'
                        }
                    </h3>
                    
                    {/* TELEFONO */}
                    
                    <div
                        className="row align-items-center mt-4"
                    >
                        <div className="col-1 text-center">
                            <p>
                                <i className="fas fa-phone-square-alt"></i>
                            </p>
                        </div>
                        <div className="col">
                            <a href={vCard} download>
                                <p>
                                    +39 333 7385857
                                    <br />
                                    +39 081 5853565
                                </p>
                            </a>
                        </div>
                    </div>
                    
                    {/* INDIRIZZO MAIL */}
                    
                    <div
                        className="row align-items-center"
                    >
                        <div className="col-1 text-center">
                            <a href="mailto:pietrolubrano86@gmail.com">
                                <p>
                                    <i className="far fa-envelope"></i>
                                </p>
                            </a>
                        </div>
                        <div className="col">
                            <a href="mailto:pietrolubrano86@gmail.com">
                                <p>pietrolubrano86@gmail.com</p>
                            </a>
                        </div>
                    </div>
                    
                    {/* LINKEDIN */}
                    
                    <div
                        className="row align-items-center"
                    >
                        <div className="col-1 text-center">
                            <a href="https://www.linkedin.com/in/pietrolubrano/" target="_blank">
                                <p>
                                    <i className="fab fa-linkedin"></i>
                                </p>
                            </a>
                        </div>
                        <div className="col">
                            <a href="https://www.linkedin.com/in/pietrolubrano/" target="_blank">
                                <p>pietrolubrano</p>
                            </a>
                        </div>
                    </div>
                    
                    {/* INDIRIZZO */}
                    
                    <div className="row align-items-center">
                        <div className="col-1 text-center">
                            <a href="https://www.google.it/maps/place/Via+Vittorio+Veneto,+144,+80145+Napoli+NA/@40.8891196,14.2407009,17z/data=!3m1!4b1!4m5!3m4!1s0x133b07cb8354d209:0xfaeaa6165b1a5ba9!8m2!3d40.8891156!4d14.2428949" target="_blank">
                                <p>
                                    <i className="fas fa-home"></i>
                                </p>
                            </a>
                        </div>
                        <div className="col">
                            <a href="https://www.google.it/maps/place/Via+Vittorio+Veneto,+144,+80145+Napoli+NA/@40.8891196,14.2407009,17z/data=!3m1!4b1!4m5!3m4!1s0x133b07cb8354d209:0xfaeaa6165b1a5ba9!8m2!3d40.8891156!4d14.2428949" target="_blank">
                                <p>via Vittorio Veneto 144<br />80145 - Napoli</p>
                            </a>
                        </div>
                    </div>
                    
                </div>
                
            </div>
            
            {/* <hr className="mb-md-4" /> */}
            
            {/* PRO SKILLS */}
            
            <div className="row mb-5">
                
                <div className="col-1 text-center me-4">
                    <i className="fas fa-chart-pie fa-2x"></i>
                </div>
                
                <div className="col">
                    <h3 className='mb-4 aos-skills'>PRO SKILLS</h3>
                    
                    {
                        proSkills.map( (skill, index) => 
                            <ProSkill key={skill.title} skill={skill} index={index}></ProSkill>
                        )
                    }

                </div>
                
            </div>

            <div className="row">
                
           {/*      <div className="col-1 text-center me-4">
                    
                </div> */}
                
                <div className="col mb-4">
                    
                    <a className='d-flex align-items-center' href="https://github.com/pietrolubrano" target="_blank" rel="noopener noreferrer">
                        <i className="fa-brands fa-github fa-2x me-3"></i>pietrolubrano
                    </a>

                </div>
                
            </div>

            {/* CODEWARS */}

            {/* <hr className="mt-md-5" /> */}

            <div className='col-12 mt-auto'
                data-aos="fade-right"
                data-aos-offset="-100"
            >
                <div className="row">
                    <div className="col-12 d-flex text-center justify-content-center tex-center">
                        <a href="https://www.codewars.com/users/pietrolubrano" target="_blank" rel="noopener noreferrer">
                            <img className="img-fluid mt-auto border" src="https://www.codewars.com/users/pietrolubrano/badges/large" style={{ filter: 'invert(100%)' }} />
                        </a>
                    </div>
                </div>
            </div>

        </aside>
    )
}